import React from "react";
import { Num, Seg, Toggle, Section, Field } from "./fields";

const scheduleFor = (years) => Array.from({ length: years }, (_, i) => Math.max(1, years - i));

export const StepFia = ({ f, set, result }) => {
  const setFactor = (age, v) => set({ payout_factors: { ...f.payout_factors, [age]: v } });
  return (
    <div className="space-y-10">
      <Section title="Premium & surrender period">
        <p className="text-sm text-exodus-muted">Single premium: the full rollover amount, moved by direct rollover into an IRA annuity with no tax at transfer.</p>
        <Seg testid="ro-fia-surr" label="Surrender period" value={f.surrender_years}
          onChange={(v) => set({ surrender_years: v, surrender_schedule: scheduleFor(v) })}
          options={[{ v: 5, label: "5 years" }, { v: 7, label: "7 years" }, { v: 10, label: "10 years" }]} />
        <Field label="Surrender charge schedule (% by year)">
          <input data-testid="ro-fia-schedule" className="input-exodus font-mono" value={f.surrender_schedule.join(", ")}
            onChange={(e) => set({ surrender_schedule: e.target.value.split(",").map((x) => Number(x.trim())).filter((x) => Number.isFinite(x)).slice(0, 20) })} />
        </Field>
        <div className="grid sm:grid-cols-2 gap-5">
          <Num testid="ro-fia-bonus" label="Premium bonus" suffix="%" step={0.5} value={f.premium_bonus} onChange={(v) => set({ premium_bonus: v })} />
          <Num testid="ro-fia-free" label="Free withdrawal / yr" suffix="%" value={f.free_withdrawal_pct} onChange={(v) => set({ free_withdrawal_pct: v })} />
        </div>
      </Section>

      <Section title="Crediting method">
        <Seg testid="ro-fia-crediting" label="Method" value={f.crediting} onChange={(v) => set({ crediting: v })}
          options={[{ v: "fixed", label: "Fixed rate" }, { v: "indexed", label: "Indexed (cap / participation / spread)" }]} />
        {f.crediting === "fixed" ? (
          <Num testid="ro-fia-fixed" label="Fixed rate" suffix="%" step={0.1} value={f.fixed_rate} onChange={(v) => set({ fixed_rate: v })} />
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            <Num testid="ro-fia-cap" label="Cap" suffix="%" step={0.25} value={f.cap} onChange={(v) => set({ cap: v })} />
            <Num testid="ro-fia-par" label="Participation" suffix="%" step={5} value={f.participation} onChange={(v) => set({ participation: v })} />
            <Num testid="ro-fia-spread" label="Spread" suffix="%" step={0.25} value={f.spread} onChange={(v) => set({ spread: v })} />
            <Num testid="ro-fia-index" label="Avg. index return" suffix="%" step={0.25} value={f.index_return} onChange={(v) => set({ index_return: v })} />
          </div>
        )}
        {result && <p data-testid="ro-fia-credited" className="text-xs text-exodus-muted">Assumed credited rate: <span className="gold-text font-mono">{result.fia.credited_rate.toFixed(2)}%</span></p>}
      </Section>

      <Section title="Lifetime income rider">
        <Toggle testid="ro-fia-rider" label="Add an income rider" value={f.rider} onChange={(v) => set({ rider: v })}
          hint="Grows a separate income base, then pays a lifetime income even if the account reaches $0." />
        {f.rider && (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              <Num testid="ro-fia-rollup" label="Roll-up rate" suffix="%" step={0.25} value={f.rollup_rate} onChange={(v) => set({ rollup_rate: v })} />
              <Num testid="ro-fia-rollup-yrs" label="Roll-up years" value={f.rollup_years} onChange={(v) => set({ rollup_years: v })} />
              <Num testid="ro-fia-rider-fee" label="Rider fee" suffix="% base" step={0.05} value={f.rider_fee} onChange={(v) => set({ rider_fee: v })} />
              <Seg testid="ro-fia-rollup-type" label="Roll-up type" value={f.rollup_type} onChange={(v) => set({ rollup_type: v })}
                options={[{ v: "compound", label: "Compound" }, { v: "simple", label: "Simple" }]} />
            </div>
            <Field label="Payout factors by age at income start (%)" hint="Ages in between are interpolated.">
              <div className="grid grid-cols-4 sm:grid-cols-7 gap-2">
                {Object.entries(f.payout_factors).sort((a, b) => Number(a[0]) - Number(b[0])).map(([age, v]) => (
                  <Num key={age} testid={`ro-fia-pf-${age}`} label={`Age ${age}`} step={0.1} value={v} onChange={(x) => setFactor(age, x)} />
                ))}
              </div>
            </Field>
          </>
        )}
      </Section>
    </div>
  );
};
